import React, { useState } from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../../router/all_routes";

const VacationInitiation = () => {
    const routes = all_routes;
    const [formData, setFormData] = useState({
        flatId: "",
        initiatedBy: "Employee",
        remarks: "",
    });

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e: any) => {
        e.preventDefault();
        console.log("Initiating Vacation:", formData);
        // Add API call here
    };

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="page-header">
                    <div className="row">
                        <div className="col-sm-12">
                            <h3 className="page-title">Vacation Initiation</h3>
                            <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                    <Link to={routes.staffQuarter.inventory.dashboard}>Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Vacation Initiation</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-8">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">Vacation Initiation Form</h5>
                            </div>
                            <div className="card-body">
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label className="form-label">Select Flat *</label>
                                        <select
                                            className="form-select"
                                            name="flatId"
                                            value={formData.flatId}
                                            onChange={handleChange}
                                            required
                                        >
                                            <option value="">Choose an occupied flat</option>
                                            <option value="1">Shastri Park - B1 - 102</option>
                                            <option value="3">Noida - A3 - 305</option>
                                            <option value="5">G. Noida - E2 - 204</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Initiated By *</label>
                                        <select
                                            className="form-select"
                                            name="initiatedBy"
                                            value={formData.initiatedBy}
                                            onChange={handleChange}
                                        >
                                            <option value="Employee">Employee</option>
                                            <option value="HR">HR / Admin</option>
                                        </select>
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Remarks *</label>
                                        <textarea
                                            className="form-control"
                                            name="remarks"
                                            rows={4}
                                            value={formData.remarks}
                                            onChange={handleChange}
                                            placeholder="Enter reason for vacation (e.g., Transfer, Retirement, Personal reasons)"
                                            required
                                        ></textarea>
                                    </div>

                                    <div className="alert alert-warning">
                                        <h6 className="alert-heading">
                                            <i className="ti ti-alert-circle me-2"></i>Important:
                                        </h6>
                                        <ul className="mb-0">
                                            <li>Flat status will change to "Vacant Initiated"</li>
                                            <li>Clearance process must be completed before final vacation</li>
                                            <li>All utility bills and dues must be cleared</li>
                                        </ul>
                                    </div>

                                    <button type="submit" className="btn btn-primary w-100">
                                        Initiate Vacation
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <div className="card">
                            <div className="card-header">
                                <h5 className="card-title">Vacation Workflow</h5>
                            </div>
                            <div className="card-body">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item d-flex align-items-start">
                                        <span className="badge bg-primary rounded-pill me-3">1</span>
                                        <div>
                                            <h6 className="mb-1">Vacation Initiation</h6>
                                            <small className="text-muted">Employee or HR initiates vacation request</small>
                                        </div>
                                    </li>
                                    <li className="list-group-item d-flex align-items-start">
                                        <span className="badge bg-light text-dark rounded-pill me-3 border">2</span>
                                        <div>
                                            <h6 className="mb-1">Clearance Process</h6>
                                            <small className="text-muted">Obtain clearances from all departments</small>
                                        </div>
                                    </li>
                                    <li className="list-group-item d-flex align-items-start">
                                        <span className="badge bg-light text-dark rounded-pill me-3 border">3</span>
                                        <div>
                                            <h6 className="mb-1">Final Vacation</h6>
                                            <small className="text-muted">Complete vacation and update status to "Vacant"</small>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default VacationInitiation;
